import type { Component, ComponentProps } from "solid-js";
import { Dynamic } from "solid-js/web";
import { Castle, Flower2, Moon, Nut, Package, ShoppingBag, Sparkles, Square } from "lucide-solid";

/**
 * Mapea el nombre de icono de `shop_product.icon` (heredado del export Stitch,
 * estilo Material) a un icono lucide-solid. Fallback: bellota (Nut). Mantiene la
 * tienda pintable aunque un producto no traiga imagen.
 */
const ICONS: Record<string, Component<ComponentProps<"svg">>> = {
  shopping_bag: ShoppingBag,
  package: Package,
  castle: Castle,
  square: Square,
  flower: Flower2,
  sparkles: Sparkles,
  moon: Moon,
};

export function ShopIcon(props: { name?: string | null; class?: string }) {
  return (
    <Dynamic
      component={props.name ? (ICONS[props.name] ?? Nut) : Nut}
      class={props.class ?? "h-6 w-6"}
    />
  );
}

/** Bellota (icono de la moneda). Reutilizable en saldo, precios y flashes. */
export function AcornGlyph(props: { class?: string }) {
  return <Nut class={props.class ?? "h-4 w-4"} />;
}

/** Formatea un importe entero de bellotas con separadores de millar. */
export function formatAcorns(amount: number): string {
  return new Intl.NumberFormat("es").format(Math.trunc(amount));
}
